<script lang="ts">
  import FizzStyles from "@shared/svelte/Components/FizzStyles.svelte";
  import SalesRepModal from "@retailer/svelte/Settings/DistributorContacts/SalesRepModal.svelte";
  import type { RetailerSalesRepContact, SalesRep } from "@shared/types/SalesRep";
  import type { SharedOrder } from "@shared/types/Order";

  export let salesReps: SalesRep[] = [];
  export let order: SharedOrder;
  export let successCallback: (newContact: RetailerSalesRepContact) => void = null;
  export let addRepToOrder: (salesRep: SalesRep) => void = null;
  export let removeRepFromOrder: (salesRep: SalesRep) => void = null;

  let showEditSalesRepModal: boolean = false;
  let editingSalesRep: SalesRep = null;
  let repErrors = [];

  let failedSalesReps = (salesReps: SalesRep[]) => {
    return salesReps.filter(rep => {
      let text_sent = rep.last_order_text != null;
      let email_sent = rep.last_order_email != null;
      let email_bounced = rep.has_email_notification_errors == true;
      let text_bounced = rep.has_phone_notification_errors == true;

      return (
        !rep.customer_service &&
        rep.is_still_assigned &&
        ((!text_sent && email_bounced) ||
          (!email_sent && text_bounced) ||
          (text_bounced && email_bounced))
      );
    });
  };

  let openEditSalesRepModal = (salesRep: SalesRep) => {
    editingSalesRep = salesRep;
    showEditSalesRepModal = true;
  };

  $: repErrors = failedSalesReps(salesReps);

</script>

<FizzStyles>
  {#each repErrors as salesRep}
    <div class="fizz-alert-warning fizz-stack-8" data-testid="delivery-failed-{salesRep.id}">
      <p style="display:inline;" class="fizz-stack-4">
        <strong class="fizz-stack-8">
          This order could not be delivered to {salesRep.name}. Please update {salesRep.name}'s
          contact information to resend your order.
        </strong>
      </p>
      <p>
        <button
          class="fizz-button fizz-button-small"
          on:click={() => openEditSalesRepModal(salesRep)}>Edit contact & resend order</button
        >
      </p>
    </div>
  {/each}

  <SalesRepModal
    bind:show={showEditSalesRepModal}
    bind:salesRep={editingSalesRep}
    {order}
    resend={true}
    {successCallback}
    {removeRepFromOrder}
    {addRepToOrder}
  />
</FizzStyles>
